import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { useStyles, useInputAdornmentStyles } from './styles';

const SliderInput = ({ width, aria, unit, startAdornmentText, ...rest }) => {
	const classes = useStyles({ width });
	const inputAdornmentClasses = useInputAdornmentStyles();

	const handleSubmitValueWithEnter = event => {
		if (event.key === 'Enter') {
			document.activeElement.blur();
		}
	};

	return (
		<TextField
			variant="filled"
			margin="dense"
			classes={classes}
			onKeyPress={handleSubmitValueWithEnter}
			InputProps={{
				startAdornment: startAdornmentText && (
					<InputAdornment position="start" classes={inputAdornmentClasses}>
						<Typography variant="body2" color="textSecondary" component="span">
							{startAdornmentText}
						</Typography>
					</InputAdornment>
				),
				endAdornment: (
					<InputAdornment position="end" classes={inputAdornmentClasses}>
						<Typography variant="body2" color="textSecondary">
							{unit}
						</Typography>
					</InputAdornment>
				)
			}}
			inputProps={{
				type: 'number',
				'aria-labelledby': aria
			}}
			{...rest}
		/>
	);
};

SliderInput.propTypes = {
	width: PropTypes.number.isRequired,
	aria: PropTypes.string.isRequired,
	unit: PropTypes.string.isRequired,
	startAdornmentText: PropTypes.string
};

export default SliderInput;
